import { Box, IconButton, MenuItem } from "@mui/material";
import { DeleteIconList, EditIconList } from "@platformx/shared/static-assets";
import { useTranslation } from "react-i18next";
import { CATEGORY_PAGE, SITE_SETTING, SUB_CATEGORY_PAGE } from "../../constants/CommonConstants";
import { ErrorTooltip } from "../ErrorTooltip/ErrorTooltip";
import { SYSTEM_TAGS } from "./constants";

const CardOption = (props: any) => {
  const { t } = useTranslation();

  const {
    dataList = {},
    tagName = "",
    category = "",
    handleEdit = () => {},
    canAccessAction,
    handleDeleteButton = () => {},
  } = props;

  const hasAccess = (action) => {
    switch (tagName) {
      case "tagscategories":
        return dataList.type === SYSTEM_TAGS ? false : canAccessAction(SITE_SETTING, "tag", action);
      case "courses":
        return false;
      case "sitepage":
        return canAccessAction(CATEGORY_PAGE, SUB_CATEGORY_PAGE, action);
      default:
        // for "article", "quiz", "poll", "event", "vod"
        return canAccessAction(category, tagName, action);
    }
  };

  return (
    <Box className='d-flex align-items-center'>
      {tagName !== "sitepage" ||
      (tagName === "sitepage" &&
        (dataList?.scheduledPublishTriggerDateTime === null ||
          dataList?.scheduledPublishTriggerDateTime === "") &&
        (dataList?.scheduledUnPublishTriggerDateTime === null ||
          dataList?.scheduledUnPublishTriggerDateTime === "")) ? (
        <ErrorTooltip
          component={
            <MenuItem
              className='icons'
              disableRipple
              onClick={handleEdit}
              disabled={!hasAccess("View")}>
              <IconButton className='hoverIcon' data-testid='edit'>
                <img src={EditIconList} alt='edit' />
              </IconButton>
            </MenuItem>
          }
          tooltipMsg={dataList.type === SYSTEM_TAGS ? t("cannot_edit_tag") : ""}
          doAccess={!hasAccess("View")}
        />
      ) : null}
      {tagName !== "sitepage" ||
      (tagName === "sitepage" &&
        (dataList?.scheduledPublishTriggerDateTime === null ||
          dataList?.scheduledPublishTriggerDateTime === undefined) &&
        (dataList?.scheduledUnPublishTriggerDateTime === null ||
          dataList?.scheduledUnPublishTriggerDateTime === undefined)) ? (
        <ErrorTooltip
          component={
            <MenuItem
              className='icons'
              disableRipple
              onClick={handleDeleteButton}
              disabled={!hasAccess("Delete") || dataList?.defaultItem === "true"}>
              <IconButton className='hoverIcon' data-testid='delete'>
                <img src={DeleteIconList} alt='delete' />
              </IconButton>
            </MenuItem>
          }
          tooltipMsg={dataList.type === SYSTEM_TAGS ? t("cannot_delete_tag") : ""}
          doAccess={!hasAccess("Delete")}
        />
      ) : null}
    </Box>
  );
};

export default CardOption;
